
export const BASE_URL = "";
export const ROUTER_ROOT = process.env.REACT_APP_URL;
export const BASE_URL_API = process.env.REACT_APP_API_URL;
export const APP_VERSION = process.env.REACT_APP_VERSION;

